export const uniqueByKey = <T>(array: Array<T>, key: string): Array<T> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return [...new Map(array.map((item: any) => [item[key], item])).values()];
};
